
import { Vue, Component } from "vue-property-decorator";
import router from "@/router";

@Component({})
export default class InvalidVerify extends Vue {}
